import { useQueryClient } from '@tanstack/react-query';
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';
import { GAMES_CONFIG } from '../config';
import { GPTGameNameType, GPTGameObjectType } from '../types';
import { useApiContext } from 'react-easyrocket';

const forEachGPTGameConfig = (
  callback: (gameObject: GPTGameObjectType, gameName: GPTGameNameType) => void
) => {
  for (const gameName in GAMES_CONFIG) {
    callback(GAMES_CONFIG[gameName as GPTGameNameType], gameName as GPTGameNameType);
  }
};

export const useGPTStateReset = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useApiContext();
  const queryClient = useQueryClient();

  useLayoutEffect(() => {
    forEachGPTGameConfig((gameObject) => {
      queryClient.resetQueries({ queryKey: [gameObject.statusUrl] });
      if (gameObject.statusUrl !== gameObject.statusUrlNonAuth) {
        queryClient.resetQueries({ queryKey: [gameObject.statusUrlNonAuth] });
      }
    });
  }, [isAuthenticated]);

  useLayoutEffect(() => {
    forEachGPTGameConfig((gameObject) => {
      queryClient.invalidateQueries({ queryKey: [gameObject.statusUrl] });
      if (gameObject.statusUrl !== gameObject.statusUrlNonAuth) {
        queryClient.invalidateQueries({ queryKey: [gameObject.statusUrlNonAuth] });
      }
    });
  }, [pathname]);
};
